import { Component, OnDestroy, OnInit, forwardRef, DoCheck } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { WorkflowComponentNew } from '../../workflow-new.component';
@Component({
  selector: 'deceased-observations',
  templateUrl: './deceased-observations.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => DeceasedObservationsComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class DeceasedObservationsComponent implements OnInit, OnDestroy {


  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  public get cardData(): models.DeceasedObservationsVM {
    return this._cardData;
  }
  public set cardData(value: models.DeceasedObservationsVM) {
    this._cardData = value;
    this.onCardDataChanged(); // Este é o método chamado quando temos mudança no cardData ( atualizado pelo step ), abaixo temos a implementação e a lógica
  }
  private _cardData: models.DeceasedObservationsVM = {} as models.DeceasedObservationsVM;

  public parentWorkflow: WorkflowComponentNew;

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  private onCardDataChanged() {

    this.cardData.additionalObservations = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedObservations?.additionalObservations;

  }

}
